import Description from './Description';
import H1 from './H1';
import H2 from './H2';
import H3 from './H3';
import H4 from './H4';
import H5 from './H5';
import H6 from './H6';
import Small from './Small';
import Standard from './Standard';
import Subtitle from './Subtitle';
import Tiny from './Tiny';
import ErrorMessage from './ErrorMessage';
import RegularText from './RegularText';
import TitleWithLine from './TitleWithLine';
import Highlighted from './Highlighted';
import Tooltip from './Tooltip';

export {
  Description,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Small,
  Standard,
  Subtitle,
  Tiny,
  ErrorMessage,
  RegularText,
  TitleWithLine,
  Highlighted,
  Tooltip,
};
